import React from 'react';
import { Check } from 'lucide-react';

const STAGES = [
  { key: 'pending', label: 'Queued' },
  { key: 'assigned', label: 'Assigned' },
  { key: 'typing', label: 'Typing' },
  { key: 'review', label: 'Review' },
  { key: 'done', label: 'Done' },
];

export default function StatusPipeline({ currentStatus }) {
  const currentIdx = STAGES.findIndex(s => s.key === currentStatus);

  return (
    <div className="w-full" data-testid="status-pipeline">
      <div className="flex items-center justify-between relative">
        {/* Connecting line */}
        <div className="absolute top-4 left-0 right-0 h-0.5 bg-[var(--brand-border)] z-0" />
        <div
          className="absolute top-4 left-0 h-0.5 bg-[var(--brand-primary)] z-0 transition-all duration-500"
          style={{ width: `${Math.max(0, (currentIdx / (STAGES.length - 1)) * 100)}%` }}
        />

        {STAGES.map((stage, i) => {
          const isComplete = i < currentIdx;
          const isCurrent = i === currentIdx;
          const isFuture = i > currentIdx;

          return (
            <div
              key={stage.key}
              className="flex flex-col items-center z-10"
              data-testid={`stage-${stage.key}`}
            >
              <div
                className={`w-8 h-8 flex items-center justify-center text-xs font-bold transition-all duration-300 ${
                  isComplete
                    ? 'bg-[var(--brand-primary)] text-white'
                    : isCurrent
                    ? 'bg-[var(--brand-primary)] text-white ring-4 ring-[var(--brand-primary)]/20'
                    : 'bg-[var(--brand-border)] text-[var(--brand-text-sec)]'
                }`}
              >
                {isComplete ? <Check size={14} /> : i + 1}
              </div>
              <span
                className={`text-[10px] mt-1.5 font-medium tracking-wide ${
                  isCurrent ? 'text-[var(--brand-primary)]' : isFuture ? 'text-[var(--brand-text-sec)]/50' : 'text-[var(--brand-text)]'
                }`}
              >
                {stage.label}
              </span>
            </div>
          );
        })}
      </div>

      {/* Status message */}
      <div className="mt-4 text-center">
        <p className="text-sm text-[var(--brand-text-sec)]" data-testid="status-message">
          {currentStatus === 'pending' && 'Waiting for a transcriber to claim your document...'}
          {currentStatus === 'assigned' && 'A transcriber has been assigned to your document.'}
          {currentStatus === 'typing' && 'Typing in progress...'}
          {currentStatus === 'review' && 'Transcription complete. Ready for your review.'}
          {currentStatus === 'done' && 'Document has been fully digitized!'}
        </p>
      </div>
    </div>
  );
}
